import React, { useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { helpers } from "@shared";

const ForgotPasswordInfo = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { state: { email } } = location;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="page-content-wrapper">
            <h1 className="page-header">Check your email</h1>
            <div className="content-box shadow-sb items-start pb-7">
                <p className="page-subheader text-left">
                    If we have an account for <b>{email}</b>, we’ll send an email from <b>mailer@suboundhomes.com</b>. Click the link in that email to create a new password to access your Sunbound account.
                </p>
                <p>
                    Please use the link immediately because it will expire <span className="underline">one hour</span> after it is sent
                </p>
            </div>
            <div className="w-full">
                <button
                    className="btn btn-primary h-14 mt-7 text-lg font-bold rounded-full"
                    type="button"
                    onClick={() => helpers.navigateNext(location, navigate)}>
                    Back to login
                </button>
            </div>
        </div>
    );
};


export default ForgotPasswordInfo;